'use client';

import React, { useRef, useEffect, useState } from 'react';
import PropertyCard, { Property } from './PropertyCard';

const properties: Property[] = [
  {
    id: 1,
    name: 'Acacia Luxury Apartments',
    location: 'Kololo, Kampala',
    country: 'Uganda',
    type: 'Serviced Apartment',
    rating: 4.97,
    reviews: 312,
    price: 180000,
    currency: 'UGX',
    badge: 'Guest favourite',
    isSuperhost: true,
    dates: 'Nov 12 – 17',
    images: [
      { src: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80', alt: 'Modern apartment living room with large windows and city views in Kampala' },
      { src: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80', alt: 'Elegant bedroom with king bed and contemporary African art' },
      { src: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800&q=80', alt: 'Fully equipped modern kitchen with granite countertops' },
    ],
  },
  {
    id: 2,
    name: 'Nile Pearl Resort & Spa',
    location: 'Jinja',
    country: 'Uganda',
    type: 'Resort',
    rating: 4.89,
    reviews: 187,
    price: 320000,
    currency: 'UGX',
    badge: 'Guest favourite',
    dates: 'Nov 5 – 10',
    images: [
      { src: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80', alt: 'Luxury resort pool overlooking the Nile River at sunset' },
      { src: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80', alt: 'Infinity pool with lush tropical gardens and river views' },
    ],
  },
  {
    id: 3,
    name: 'Bwindi Forest Lodge',
    location: 'Bwindi, Kabale',
    country: 'Uganda',
    type: 'Eco Lodge',
    rating: 4.95,
    reviews: 94,
    price: 450000,
    currency: 'UGX',
    isSuperhost: true,
    dates: 'Dec 1 – 6',
    images: [
      { src: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80', alt: 'Eco lodge nestled in the Bwindi Impenetrable Forest with mountain views' },
      { src: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80', alt: 'Cozy lodge room with wooden furnishings and forest views' },
    ],
  },
  {
    id: 4,
    name: 'Entebbe Lakeside Villa',
    location: 'Entebbe',
    country: 'Uganda',
    type: 'Villa',
    rating: 4.82,
    reviews: 256,
    price: 280000,
    currency: 'UGX',
    badge: 'Guest favourite',
    dates: 'Nov 20 – 25',
    images: [
      { src: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800&q=80', alt: 'Lakeside villa with private dock and Lake Victoria views' },
      { src: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800&q=80', alt: 'Villa swimming pool with tropical garden and lake backdrop' },
    ],
  },
  {
    id: 5,
    name: 'Mbarara Heritage Hotel',
    location: 'Mbarara',
    country: 'Uganda',
    type: 'Boutique Hotel',
    rating: 4.76,
    reviews: 143,
    price: 150000,
    currency: 'UGX',
    dates: 'Nov 8 – 13',
    images: [
      { src: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80', alt: 'Boutique hotel room with African-inspired decor and comfortable furnishings' },
      { src: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&q=80', alt: 'Hotel restaurant with local cuisine and warm ambiance' },
    ],
  },
  {
    id: 6,
    name: 'Fort Portal Mountain Retreat',
    location: 'Fort Portal',
    country: 'Uganda',
    type: 'Mountain Lodge',
    rating: 4.91,
    reviews: 78,
    price: 200000,
    currency: 'UGX',
    isSuperhost: true,
    dates: 'Dec 10 – 15',
    images: [
      { src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80', alt: 'Mountain retreat with panoramic views of the Rwenzori Mountains' },
      { src: 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80', alt: 'Cozy mountain lodge interior with fireplace and wooden beams' },
    ],
  },
  {
    id: 7,
    name: 'Kampala City Suites',
    location: 'Nakasero, Kampala',
    country: 'Uganda',
    type: 'Hotel',
    rating: 4.68,
    reviews: 421,
    price: 120000,
    currency: 'UGX',
    dates: 'Nov 15 – 20',
    images: [
      { src: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80', alt: 'Modern hotel suite with city views and contemporary furnishings in Kampala' },
      { src: 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=800&q=80', alt: 'Hotel rooftop bar with panoramic Kampala skyline views' },
    ],
  },
  {
    id: 8,
    name: 'Ssese Islands Beach Resort',
    location: 'Ssese Islands',
    country: 'Uganda',
    type: 'Beach Resort',
    rating: 4.88,
    reviews: 165,
    price: 380000,
    currency: 'UGX',
    badge: 'Guest favourite',
    dates: 'Dec 20 – 25',
    images: [
      { src: 'https://images.unsplash.com/photo-1439130490301-25e322d88054?w=800&q=80', alt: 'Tropical beach resort on Ssese Islands with white sand and clear lake water' },
      { src: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80', alt: 'Beach bungalow with hammock and lake views at sunset' },
    ],
  },
];

export default function FeaturedProperties() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-10 px-4 sm:px-6 max-w-7xl mx-auto">
      <div className={`mb-6 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
        <h2 className="text-2xl font-bold text-gray-900">Places to stay in Uganda</h2>
        <p className="text-gray-500 mt-1">Discover unique accommodations handpicked for you</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {properties.map((property, i) => (
          <div
            key={property.id}
            className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ transitionDelay: `${i * 60}ms` }}
          >
            <PropertyCard property={property} />
          </div>
        ))}
      </div>

      <div className="mt-10 text-center">
        <button className="border border-gray-900 text-gray-900 font-semibold px-8 py-3 rounded-xl hover:bg-gray-50 transition-colors">
          Show more stays
        </button>
      </div>
    </section>
  );
}
